export enum WorkTypeEnum {
  'Full time' = 'Full time',
  'Part time' = 'Part time',
  Freelance = 'Freelance',
  Custom = 'Custom',
}
